import React, { Component } from 'react'
import { Button, Checkbox, Dimmer, Grid, Icon, Segment, Form, Loader } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { DATASOURCE } from 'Constants'
import { getApiData } from 'helpers/api'
import EULA from 'lib/docs/PolycomEndUserLicenseAgreementALLPRODUCTS.pdf'
import EXPORT from 'lib/docs/PolycomExportRestrictions.pdf'
import DOCS from 'lib/docs/RC_Invite_Dep_Guide.docx'

class Modality extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agreed:false
    }
  };

  code = "RIWak2CKsaL1kv8ZLacaU6WUKYeOOrgMGBrGsbLt24zsPzIY0TadFw%3D%3D"

  componentDidMount() {
    getApiData(DATASOURCE.MODALITY,"code=" + this.code);
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <p>{t("Screens.Modality.Paragraph")}</p>
        <Checkbox id="AgreeExportAndEULA"
          onChange={() => this.setState({ agreed: !this.state.agreed})}
        /> I agree to the <a id="EULA" href={EULA} target="_blank" rel="noopener noreferrer">License Agreement</a> and <a id="ExportRestrictions" href={EXPORT} target="_blank" rel="noopener noreferrer">Export Restrictions</a> 
        <Dimmer.Dimmable as={Segment} blurring dimmed={!this.state.agreed}>
          <Dimmer active={this.props.modalityLoading || !this.state.agreed} inverted>
            {this.props.modalityLoading && <Loader />}
          </Dimmer>
          <Grid columns={4} divided textAlign='center' verticalAlign='middle'>
            {Object.keys(this.props.modalityDetail).map(arch => { 
              return (
                <Grid.Row key={arch}>
                  <Grid.Column width={2}>
                    <Form action={DATASOURCE.MODALITY.URL+"?code="+this.code} method="POST">
                      <Form.Field>
                        <input type="hidden" id="name" name="name" value="darkness" />
                      </Form.Field>
                      <Form.Field>
                        <input type="hidden" id="type" name="type" value={arch} />
                      </Form.Field>
                      <Button icon type="submit" id={"Download["+arch+"]MSI"}>
                        <Icon name="download" title="Download MSI" />
                      </Button>
                      <Button icon type="button"
                        href={DOCS} target="_blank" rel="noopener noreferrer"
                      >
                        <Icon name="file text" title="Download Documentation" />
                      </Button>
                    </Form>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    {this.props.modalityDetail[arch].file}
                  </Grid.Column>
                  <Grid.Column width={6}>
                    MD5: {this.props.modalityDetail[arch].md5}
                  </Grid.Column>
                  <Grid.Column width={3}>
                    {this.props.modalityDetail[arch].date}
                  </Grid.Column>
                </Grid.Row>
              )
            })}
          </Grid>
        </Dimmer.Dimmable>

      </div>
    )
  }
}

// REDUX STATE
const mapToProps = state => {
  return {
    modalityDetail: state.modality.data,
    modalityLoading: state.modality.loading
  }
};

export default translate()(
  connect(
    mapToProps,
    null
  )(Modality)
);
